export default __webpack_public_path__ + "static/media/Razor1.e310a46e.mp3";